import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';

@Component({
    selector: 'ifb-client-update-dialog',
    templateUrl: './client-update-dialog.component.html',
    styleUrls: ['./client-update-dialog.component.css'],
    standalone: false
})
export class ClientUpdateDialogComponent {
  actionGerund: string;

  constructor(public dialogRef: MatDialogRef<ClientUpdateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.actionGerund = this.data.action.substring(0, this.data.action.length - 1) + "ing";
  }

  static show(dialog: MatDialog, form: UntypedFormGroup, action: string): Observable<any> {
    return dialog.open(ClientUpdateDialogComponent, {
      width: '510px',
      data: {
        form: form,
        action: action
      },
      closeOnNavigation: true,
    }).afterClosed();
  }
}

